import { render } from "./FeedbackBanner.vue?vue&type=template&id=e96fd25e&scoped=true"
import script from "./FeedbackBanner.vue?vue&type=script&lang=js"
export * from "./FeedbackBanner.vue?vue&type=script&lang=js"

import "./FeedbackBanner.vue?vue&type=style&index=0&id=e96fd25e&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96fd25e"]])

export default __exports__